import { Center, Image } from "@mantine/core";

export function OffLogo() {
  return (
    <Center>
      <Image src="/assets/off_logo_transparent.png" alt="off logo" w="30%" />
    </Center>
  );
}
